import * as React from 'react';
import { useTranslate } from 'react-admin';
import { Typography } from '@mui/material';
export var ArrayFieldDescriptionTemplate = function (props) {
    var description = props.schema.description;
    var translate = useTranslate();
    var translatedDescription = typeof description === 'string'
        ? translate(description, { _: description })
        : description;
    return (React.createElement(Typography, { variant: "subtitle2", color: "text.secondary", sx: { mt: 0.5 } }, translatedDescription));
};
